var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarBayrun4Rent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1194,
    height: 497,
    viewBox: "0 0 1194 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10396_19693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1194,
    height: 497
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1193.16 0H0V496.355H1193.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10396_19693)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10396_19693",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1194,
    height: 497
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.16 0H0.00274658V496.355H1193.16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10396_19693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.237 443.931C128.791 444.962 139.006 445.542 139.006 445.542L139.106 445.442L140.513 445.542C144.847 445.923 149.539 446.433 153.873 446.653C168.211 447.604 182.808 448.384 197.176 448.665C212.762 449.155 228.608 449.365 244.193 449.365C250.803 449.405 257.882 449.075 264.492 448.865C267.098 448.635 271.491 447.184 273.858 446.413L274.337 451.577H274.347C273.628 451.667 272.909 451.827 272.23 452.077C271.771 452.227 270.942 452.507 270.513 452.988C270.163 453.398 270.213 453.698 270.213 453.698C270.523 458.211 271.871 464.276 272.929 468.699C273.309 470.27 273.698 471.841 274.117 473.402C274.497 474.793 274.886 476.174 275.325 477.545C275.695 478.676 276.054 479.857 276.643 480.888C278.82 484.71 281.945 490.715 284.781 493.877C284.781 493.877 285.36 494.678 286.488 494.778L288.395 494.878C289.004 494.878 293.048 491.105 293.408 490.464C293.617 490.074 293.687 489.664 293.428 489.234H293.527L294.236 489.634H294.336L297.801 488.043C297.801 488.043 297.841 488.063 297.851 488.073C298.61 487.773 298.29 486.842 298.35 486.201C296.673 478.136 293.028 464.926 291.041 456.8C291.021 456.73 291.001 456.67 290.981 456.6L290.043 453.778C289.953 453.518 289.793 453.288 289.574 453.128L287.477 451.567C287.297 451.427 287.087 451.317 286.878 451.246L285.5 450.736C285.031 449.085 284.881 447.564 285.13 446.223H286.239L369.39 446.043C413.373 446.903 504.193 447.784 504.193 447.784C581.224 448.374 669.248 448.745 758.99 448.675L795.563 448.805C795.563 448.805 1031.82 447.364 1130.44 445.092C1132.56 445.042 1136.1 445.032 1136.1 445.032C1136.42 445.172 1136.65 445.432 1137 445.432C1145.29 444.662 1157.23 443.611 1165.14 441.299H1166.24C1166.24 441.299 1166.74 441.379 1167.05 440.599C1167.05 440.599 1169.98 439.658 1170.16 439.588C1170.16 439.588 1172.4 438.988 1172.97 438.277L1173.5 437.757L1173.76 437.477L1174.63 435.675C1174.63 435.675 1177.68 429.361 1179.24 421.035C1183.62 411.308 1185.96 399.54 1187.35 388.762C1187.49 387.701 1187.57 386.73 1187.64 385.86C1190.35 350.515 1192.55 285.138 1192.28 250.663C1192.28 250.083 1192.28 245.049 1192.28 244.078C1192.5 209.324 1190.31 144.988 1187.64 110.023C1187.57 109.152 1187.49 108.181 1187.35 107.121C1185.96 96.343 1183.62 84.5746 1179.24 74.8476C1177.68 66.5217 1174.63 60.2072 1174.63 60.2072L1173.76 58.4059L1173.5 58.1257L1172.97 57.6053C1172.4 56.8948 1170.16 56.2944 1170.16 56.2944C1169.97 56.2243 1167.05 55.2937 1167.05 55.2837C1166.74 54.5031 1166.24 54.5731 1166.24 54.5731H1165.14C1157.23 52.2715 1145.29 51.2208 1137 50.4502C1136.65 50.4502 1136.41 50.7104 1136.1 50.8505C1136.1 50.8505 1132.56 50.8305 1130.44 50.7904C1031.82 48.5188 795.563 47.0778 795.563 47.0778L758.99 47.2079C669.248 47.1478 581.224 47.5081 504.193 48.0985C504.193 48.0985 413.363 48.9691 369.39 49.8398L286.239 49.6596H285.13C284.881 48.3287 285.031 46.8076 285.5 45.1564L286.878 44.636C287.087 44.556 287.297 44.4459 287.477 44.3158L289.574 42.7547C289.793 42.5946 289.963 42.3644 290.043 42.1042L290.981 39.2822C291.001 39.2122 291.021 39.1521 291.041 39.0821C293.028 30.9563 296.663 17.7368 298.35 9.68108C298.29 9.04062 298.61 8.11997 297.851 7.80974C297.831 7.80974 297.811 7.82976 297.801 7.83976L294.336 6.24863H294.236L293.527 6.64891H293.428C293.687 6.21861 293.617 5.80831 293.408 5.41803C293.048 4.77758 289.004 1.00488 288.395 1.00488L286.488 1.10495C285.36 1.20503 284.781 2.0056 284.781 2.0056C281.945 5.17786 278.82 11.1822 276.643 14.9949C276.054 16.0256 275.695 17.2065 275.325 18.3373C274.886 19.7082 274.487 21.0892 274.117 22.4802C273.698 24.0413 273.309 25.6025 272.929 27.1836C271.871 31.6067 270.533 37.6711 270.213 42.1843C270.213 42.1843 270.163 42.4845 270.513 42.8948C270.932 43.3651 271.771 43.6553 272.23 43.8055C272.909 44.0556 273.628 44.2157 274.347 44.2958H274.337L273.888 49.4995C271.521 48.739 267.098 47.2579 264.492 47.0278C257.882 46.8176 250.803 46.4874 244.193 46.5274C228.608 46.5274 212.752 46.7476 197.176 47.2279C182.798 47.5081 168.211 48.2887 153.873 49.2393C149.539 49.4495 144.847 49.9699 140.513 50.3501L139.106 50.4502L139.006 50.3501C139.006 50.3501 128.791 50.9305 125.237 51.9613M125.536 51.8612C121.792 52.1814 117.928 53.002 114.284 53.9727C110.28 55.6239 103.56 58.2758 99.616 60.1171L99.0071 60.2172L84.2399 62.4388C68.8336 64.3101 52.7584 68.353 41.1363 79.2508C34.237 85.8855 28.8951 94.4016 24.7615 103.018C18.5111 115.377 13.0096 128.936 9.78463 142.396C9.78463 142.396 9.27542 142.766 8.58648 145.118C6.67942 150.962 6.29002 162.85 5.67097 168.885C4.92213 179.292 3.89372 190.49 3.06499 200.908C1.3776 215.748 0.848412 231.67 1.03812 247.941C0.848412 264.213 1.3776 280.124 3.06499 294.975C3.89372 305.392 4.92213 316.59 5.67097 326.998C6.29002 333.032 6.67942 344.921 8.58648 350.765C9.2854 353.116 9.78463 353.487 9.78463 353.487C13.0096 366.946 18.5111 380.506 24.7615 392.865C28.8951 401.481 34.237 409.997 41.1363 416.632C52.7584 427.54 68.8336 431.572 84.2399 433.444L99.0071 435.665L99.616 435.765C103.56 437.607 110.28 440.259 114.284 441.91C117.928 442.891 121.792 443.711 125.536 444.021",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.91 99.2529V99.6532V100.053L1155.61 100.864L1157.03 108.31L1164.64 176.979L1167.18 246.018V246.078L1164.64 315.067L1157.03 383.736L1155.35 393.323",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.61 393.323L1159.32 384.023L1160.53 377.178L1161.63 370.033L1162.83 361.367L1164.04 352.301L1165.05 342.734L1166.15 331.356L1167.06 319.077L1167.87 306.288L1168.47 293.098L1168.97 279.098L1169.37 261.065L1169.47 252.009L1169.48 246.065V244.654C1169.96 183.07 1163.36 135.065 1163.36 135.065C1161.29 118.313 1157.84 100.631 1157.84 100.631V99.68L1155.93 91.8244C1154.97 87.6491 1155.95 84.6207 1156.64 83.1631",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.51 102.667L1140.66 175.069L1143.39 247.881L1140.66 320.693L1132.51 393.094",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.27 102.767L1133.41 175.088L1136.13 247.83V247.88L1133.41 320.562L1125.27 392.884",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.96 395.606L1128.51 322.644L1132.34 247.731L1128.51 172.817L1119.96 99.8555",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.083 427.165C184.315 413.666 175.069 395.501 169.348 377.186C158.714 337.744 154.461 289.921 156.288 249.139C154.95 205.819 158.485 155.265 172.263 114C176.247 103.039 181.699 92.3396 188.638 82.9704C191.084 79.4846 194.648 75.7672 197.584 72.624L198.493 71.8179C198.493 71.8179 200.899 69.5815 200.899 69.5916C200.979 69.4505 201.009 69.3698 200.999 69.1885H200.899",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.885 387.13C147.512 343.439 146.883 290.011 146.883 247.961C146.883 205.911 147.512 152.482 164.885 108.791C166.193 106.059 169.438 99.0142 171.026 96.5024C172.354 93.6003 170.267 91.2987 167.172 92.5095C161.72 94.3509 151.616 96.4524 145.385 98.744C141.561 100.155 140.433 101.346 138.226 104.048C131.057 115.846 124.797 140.504 123.579 147.849C117.988 177.24 117.778 210.764 118.067 247.961C117.778 285.157 117.988 318.681 123.579 348.072C124.797 355.417 131.057 380.075 138.226 391.873C140.423 394.575 141.561 395.766 145.385 397.177C151.616 399.479 161.72 401.58 167.172 403.412C170.267 404.622 172.364 402.331 171.026 399.419C169.428 396.907 166.193 389.862 164.885 387.13Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.264 247.96C149.224 205.809 149.124 132.807 177.171 88.1455L147.526 96.2013C143.802 97.232 140.657 98.643 137.991 101.075C136.963 102.015 136.144 103.156 135.525 104.407C115.206 145.616 115.396 197.303 115.396 247.95C115.396 298.606 115.206 350.303 135.525 391.502C136.144 392.753 136.963 393.904 137.991 394.834C140.657 397.266 143.802 398.677 147.526 399.708L177.171 407.764C149.124 363.102 149.224 290.1 149.264 247.95V247.96Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23137 249.301C6.36962 263.871 9.38497 314.478 10.7429 323.964C13.269 336.353 18.5908 349.292 27.5769 358.389V358.289L27.6768 358.189H27.7766C27.8765 358.289 28.0762 358.489 28.176 358.589L28.4755 358.489C28.5255 358.409 28.6952 358.149 28.7751 358.089C29.0546 357.028 28.9947 355.527 28.8749 354.466C28.166 347.861 26.1891 336.884 25.4602 330.299C22.7444 310.625 21.0769 289.91 20.3381 270.076C20.0685 264.912 19.3296 247.94 19.3296 247.94C19.3296 247.94 20.0685 230.968 20.3381 225.804C21.0769 205.97 22.7544 185.255 25.4602 165.581C26.1891 158.997 28.166 148.019 28.8749 141.414C28.9947 140.343 29.0447 138.852 28.7751 137.791C28.6952 137.741 28.5255 137.471 28.4755 137.391L28.176 137.291C28.0762 137.391 27.8765 137.591 27.7766 137.691H27.6768L27.5769 137.591V137.491C18.6008 146.578 13.269 159.517 10.7429 171.916C9.37498 181.403 6.35963 232.009 5.23137 246.579C5.16148 247.5 5.16148 248.39 5.23137 249.311V249.301Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.708 92.0205H477.174V99.9261H500.708V92.0205Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.716 395.994H477.203V403.95H500.716V395.994Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.425 65.4932C206.395 65.6333 206.205 65.7633 206.225 65.8934C246.583 68.4452 288.338 73.2987 328.307 79.3931C328.237 80.0736 329.126 81.6147 329.315 82.8155C329.595 84.3766 328.107 86.6283 327.808 88.1493",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.064 199.525V199.826C214.884 200.176 214.475 200.516 214.155 200.736C213.227 200.886 208.344 201.727 207.426 201.847C206.747 202.097 205.958 201.787 205.618 201.147C205.529 200.616 205.499 199.876 205.519 199.325L207.106 171.826L211.07 144.566L217.37 117.757C217.46 117.397 217.73 116.766 218.079 116.546C219.068 116.216 222.223 115.926 223.301 115.736C223.611 115.686 224.02 115.816 224.3 115.936C224.37 116.046 224.469 116.306 224.499 116.436C219.048 143.555 216.572 171.916 215.054 199.515L215.064 199.525Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.957 59.1469C113.319 56.455 119.639 54.0933 125.241 52.0018C128.795 50.971 139.01 50.3906 139.01 50.3906L139.109 50.4907V50.8209",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6144 60.1534C103.559 58.312 110.278 55.6601 114.282 54.009C117.927 53.0283 121.791 52.2077 125.535 51.8975",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.735 73.7487C328.729 72.6479 271.417 65.9131 263.1 64.0818C260.047 63.3474 257.433 61.5924 254.396 60.916",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.683 68.6139C219.854 57.1357 229.499 58.5167 250.826 60.258L254.396 60.9161",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.781 73.7458L486.545 73.7158V73.7458L486.844 73.8559L487.044 74.0461L487.144 74.2462M487.144 74.2462V78.8895M487.144 74.2462V89.1568L487.044 89.4571L486.844 89.7573H486.545L481.822 89.7672L475.891 89.6571",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.573 47.1123L795.403 47.2924L795.303 47.5926L795.194 76.6934L794.694 78.2045L487.139 78.7149L487.238 48.7034L486.939 48.1931",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.455 73.7451C370.027 74.2555 443.503 73.8052 475.804 73.7451L475.903 89.6564C447.308 89.4462 418.352 88.7158 389.796 87.0346C379.572 86.2941 369.048 85.5034 358.854 84.5227C349.798 83.532 338.725 81.9008 329.719 80.2897C329.719 80.1396 329.719 79.8394 329.719 79.6893C331.896 77.3076 334.821 75.0861 337.756 73.7451H338.455Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.174 109.094C60.3967 102.749 73.7761 99.2865 86.147 96.1042C113.774 89.3094 153.273 82.5245 181.2 76.8705C183.976 75.9699 186.352 73.8482 188.928 72.5373C192.503 70.5659 196.666 69.265 200.69 68.6045",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.576 137.49V136.99L28.2749 132.256C28.2749 132.256 28.4646 131.556 28.7741 130.695",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2352 81.606C55.0716 84.508 51.1677 88.2507 47.6531 92.1835C47.3336 92.5638 46.9941 92.9641 46.6446 93.3844C44.2583 96.2664 42.3513 99.1385 40.8536 102.151C36.5602 111.137 32.2369 121.405 28.7922 130.751C30.7991 127.869 33.3751 125.147 35.7215 122.596C40.3044 117.482 46.8643 112.138 51.0978 106.784C60.9027 95.0856 69.1899 81.1857 81.8204 72.2793C74.0324 74.601 66.1645 77.3229 59.2352 81.606Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.806 72.2753C81.806 72.2753 81.8859 72.2453 81.9358 72.2353L82.1355 72.0352C82.0257 72.1152 81.9159 72.1953 81.806 72.2753Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.135 72.0325C87.1972 68.8402 93.0382 66.9789 98.8093 65.5879C131.04 61.2148 221.83 56.3613 253.241 56.3213L267.933 60.1638",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.331 57.8668C126.731 55.1349 133.86 52.3829 140.52 50.3915C144.853 50.0112 149.546 49.5009 153.879 49.2807C168.217 48.33 182.815 47.5495 197.183 47.2693C212.768 46.7789 228.614 46.5688 244.2 46.5688C250.81 46.5287 257.889 46.859 264.499 47.0691C267.484 47.3393 270.909 48.6102 273.894 49.5409",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04398 247.983C0.854269 231.711 1.38346 215.79 3.07085 200.949C3.89958 190.532 4.92799 179.334 5.67684 168.926C6.29588 162.892 6.68528 151.003 8.59234 145.159C9.28128 142.808 9.79049 142.437 9.79049 142.437C13.0155 128.978 18.517 115.418 24.7673 103.059C28.9009 94.4433 34.2428 85.9272 41.1422 79.2925C52.7643 68.3947 68.8395 64.3518 84.2457 62.4805L99.0129 60.2589L117.304 58.0473L197.99 53.6141L199.997 53.5141L253.544 52.2031L266.429 54.1479",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.713 443.3C339.312 442.96 435.284 442.87 452.717 442.569C454.224 442.539 455.712 442.309 457.13 441.799C460.824 440.488 464.339 438.346 466.306 434.874C467.334 433.043 468.193 430.851 468.153 428.719C467.823 427.208 465.986 426.648 464.638 426.408C461.882 425.657 458.727 425.627 455.892 425.397C431.879 425.157 391.012 425.517 367.069 425.397C352.94 425.157 337.884 426.538 323.865 428.519C300.002 431.271 274.761 433.983 250.818 435.664C251.118 436.475 251.247 438.206 252.525 437.576C253.813 439.267 252.625 441.809 253.334 443.62L253.534 443.72C256.09 443.6 262.72 443.5 271.616 443.42",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.714 53.8125C269.773 54.9033 270.312 55.8239 271.52 56.0341L291.469 57.2349L289.403 54.1127",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.714 53.8115C270.482 53.4212 272.279 52.2704 273.337 50.9895L273.747 50.289C274.316 48.4176 274.386 46.3161 274.346 44.3447",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.994 39.3016C291.014 39.2315 291.034 39.1715 291.054 39.1014C293.041 30.9756 296.676 17.7562 298.363 9.70044C298.303 9.05998 298.623 8.13932 297.864 7.8291C292.562 10.521 291.673 17.8863 290.026 23.2901C288.778 28.2437 286.042 39.1915 285.004 43.9349C285.014 44.3852 284.594 45.3059 285.303 45.2458L286.891 44.6654C287.1 44.5853 287.31 44.4753 287.49 44.3452L289.587 42.7841C289.806 42.6239 289.976 42.3938 290.056 42.1336L290.994 39.3116V39.3016Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.718 53.8166L266.212 54.1168L268.188 59.971C268.328 60.3913 268.698 60.6915 269.137 60.7215C279.052 61.5321 290.864 62.6929 300.748 63.6236C300.958 63.6436 301.068 63.3834 300.918 63.2333L292.032 54.6172L289.416 54.1168C285.023 52.6758 284.344 49.2934 285.502 45.1904",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.103 45.2429C281.798 46.0335 277.954 45.0828 274.719 44.3623",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.435 6.67821C293.695 6.2479 293.625 5.83761 293.415 5.44733C293.056 4.80687 289.012 1.03418 288.403 1.03418L286.496 1.13425C285.368 1.23432 284.789 2.03489 284.789 2.03489C281.953 5.20716 278.828 11.2114 276.651 15.0241C276.062 16.0548 275.703 17.2357 275.333 18.3665C274.894 19.7375 274.495 21.1185 274.125 22.5094C273.706 24.0706 273.316 25.6317 272.937 27.2128C271.879 31.636 270.541 37.7003 270.221 42.2135C270.221 42.2135 270.171 42.5137 270.521 42.924C270.94 43.3944 271.779 43.6846 272.238 43.8347C274.664 44.7153 277.51 44.6252 279.467 42.924C280.775 42.1835 281.224 38.2807 281.673 36.9798C283.88 29.3043 286.097 17.9062 289.212 11.0012C289.212 11.0012 289.751 10.0405 290.031 9.63032C290.799 8.49951 292.796 6.16785 293.435 6.67821Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.714 442.122C269.773 441.031 270.312 440.11 271.52 439.9L291.469 438.699L289.403 441.821",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.714 442.119C270.482 442.509 272.279 443.66 273.337 444.941L273.747 445.642C274.316 447.513 274.386 449.615 274.346 451.586",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.994 456.62C291.014 456.69 291.034 456.75 291.054 456.82C293.041 464.946 296.676 478.165 298.363 486.221C298.303 486.861 298.623 487.782 297.864 488.092C292.562 485.4 291.673 478.035 290.026 472.631C288.778 467.678 286.042 456.73 285.004 451.987C285.014 451.536 284.594 450.616 285.303 450.676L286.891 451.256C287.1 451.336 287.31 451.446 287.49 451.576L289.587 453.137C289.806 453.298 289.976 453.528 290.056 453.788L290.994 456.61V456.62Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.718 442.121L266.212 441.82L268.188 435.966C268.328 435.546 268.698 435.246 269.137 435.216C279.052 434.405 290.864 433.244 300.748 432.314C300.958 432.294 301.068 432.554 300.918 432.704L292.032 441.32L289.416 441.82C285.023 443.261 284.344 446.644 285.502 450.747",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.103 450.678C281.798 449.888 277.954 450.838 274.719 451.559",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.435 489.246C293.695 489.677 293.625 490.087 293.415 490.477C293.056 491.118 289.012 494.89 288.403 494.89L286.496 494.79C285.368 494.69 284.789 493.89 284.789 493.89C281.953 490.717 278.828 484.713 276.651 480.9C276.062 479.87 275.703 478.689 275.333 477.558C274.894 476.187 274.495 474.806 274.125 473.415C273.706 471.854 273.316 470.293 272.937 468.712C271.879 464.289 270.541 458.224 270.221 453.711C270.221 453.711 270.171 453.411 270.521 453.001C270.94 452.53 271.779 452.24 272.238 452.09C274.664 451.209 277.51 451.299 279.467 453.001C280.775 453.741 281.224 457.644 281.673 458.945C283.88 466.62 286.097 478.018 289.212 484.923C289.212 484.923 289.751 485.884 290.031 486.294C290.799 487.425 292.796 489.757 293.435 489.246Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.432 81.0199C275.432 81.0199 277.269 87.8748 267.315 87.2543C267.315 87.2543 254.974 86.9241 242.193 84.3622C242.193 84.3622 226.408 81.24 209.065 76.6768C209.065 76.6768 201.167 91.3873 196.614 105.537C196.614 105.537 196.424 105.918 196.823 106.098L197.582 106.278C197.582 106.278 189.455 129.174 185.321 169.193C185.321 169.193 180.968 206.009 181.307 247.969",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.323 79.9375H203.209C203.209 79.9375 196.47 94.658 193.724 103.825C193.724 103.825 187.004 113.221 185.816 118.285C185.756 118.555 185.726 118.825 185.726 119.106L185.667 130.804L180.584 159.895L181.673 160.695L179.955 172.954C179.955 172.954 178.987 173.585 178.867 174.445C178.867 174.445 176.011 208.069 175.692 218.166L175.243 230.665C175.243 230.665 175.592 231.686 176.191 232.066L176.151 240.572",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.649 247.961C169.919 118.459 199.274 74.9676 199.274 74.9676L200.681 74.6973H201.3C251.144 76.9389 329.203 88.2369 329.203 88.2369",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.084 247.96V242.186L175.853 241.615L176.402 241.485V247.96H175.084Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.084 242.182L175.513 241.282L176.202 240.571L176.552 241.102L175.933 241.442L175.084 242.182Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.732 202.046C255.746 201.646 270.753 201.015 272.929 201.536C274.597 202.437 277.842 209.972 278.6 211.503C278.62 211.543 278.66 211.683 278.66 211.723C278.68 212.103 278.58 212.484 278.251 212.714C277.682 213.134 259.909 213.354 256.544 212.814C255.895 212.814 252.081 204.778 251.422 203.747C251.283 203.487 251.083 203.047 251.123 202.747C251.123 202.747 251.063 202.146 251.722 202.046H251.732Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.084 202.129C218.084 202.129 255.956 198.406 271.641 198.306C279.839 198.196 288.226 198.066 296.353 199.317C299.498 203.44 302.544 208.413 304.291 213.317C304.291 213.317 305.3 216.279 305.389 216.649V216.629C305.549 217.189 304.651 216.889 304.651 216.889C300.267 215.148 238.103 216.739 217.275 216.229C217.275 216.229 217.515 206.662 218.084 202.129ZM218.084 202.129C217.974 202.949 217.984 202.129 217.984 202.129H218.084Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.884 200.739C285.979 200.799 289.464 200.849 292.529 201.25C292.529 201.25 293.078 201.3 293.737 202.26C294.636 203.571 295.944 205.473 296.653 206.894C297.741 208.785 298.909 211.137 299.468 213.238C299.518 213.468 299.369 213.438 299.369 213.438C296.363 213.268 293.028 213.268 289.993 213.148C289.694 213.138 289.404 213.018 289.204 212.788C288.515 211.987 288.006 210.306 287.607 209.616C286.309 206.824 283.882 203.751 282.285 201.16C282.285 201.16 281.935 200.659 282.884 200.759V200.739Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.249 198.715C295.111 169.665 291.876 112.063 289.919 82.9023",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.821 85.4258C247.552 95.4329 239.524 172.848 241.791 180.794C242.739 187.548 246.384 193.973 251.536 198.416C252.754 198.346 254.441 198.186 255.659 198.016C250.497 193.633 246.603 187.548 245.515 180.794C243.248 173.088 250.467 95.553 250.637 85.9361L247.821 85.4358V85.4258Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.151 217.049L267.397 216.979L283.482 216.949H287.905C287.905 216.949 291.37 230.299 291.37 247.961",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.391 199.344L297.379 199.514C297.379 199.514 304.328 207.61 306.835 217.377L305.626 218.067L305.457 217.587C305.457 217.587 294.234 216.116 289.831 216.856C289.831 216.856 293.196 232.988 293.196 247.958",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.941 223.202L291.43 221.981C291.43 221.981 299.398 222.132 300.996 222.422L301.525 223.442V224.123C301.525 224.123 303.512 233.51 303.512 247.96",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.189 247.96L293.321 229.617C293.321 229.617 293.321 229.037 293.95 229.037H300.41C300.41 229.037 301.239 228.746 301.328 230.638C301.328 230.638 302.347 237.342 302.347 247.96",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.009 247.964C308.009 135.043 330.465 92.9825 330.465 92.9825C329.426 92.1319 330.385 90.9711 330.385 90.9711C331.084 89.1497 329.766 88.5293 329.766 88.5293C329.107 88.5693 329.147 87.8288 329.147 87.8288L330.495 83.916L334.349 84.5064C334.349 84.5064 337.873 85.237 335.447 89.2298L334.439 92.0318C334.439 92.0318 311.514 129.379 311.514 247.954",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.101 88.8066L335.453 89.2369",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.506 89.7119L335.109 90.1022",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.077 90.0265C335.077 90.0265 337.354 90.1666 338.003 84.0723C338.003 84.0723 338.053 83.1416 339.81 83.5119C339.81 83.5119 360.278 88.4154 402.423 89.266L477.178 92.0179",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.313 92.0791L359.175 95.3915L477.173 99.9347",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.425 430.442C206.395 430.302 206.205 430.172 206.225 430.042C246.583 427.49 288.338 422.637 328.307 416.542C328.237 415.862 329.126 414.321 329.315 413.12C329.595 411.559 328.107 409.307 327.808 407.786",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.064 296.405V296.105C214.884 295.755 214.475 295.415 214.155 295.194C213.227 295.044 208.344 294.204 207.426 294.084C206.747 293.833 205.958 294.144 205.618 294.784C205.529 295.314 205.499 296.055 205.519 296.605L207.106 324.105L211.07 351.364L217.37 378.174C217.46 378.534 217.73 379.164 218.079 379.385C219.068 379.715 222.223 380.005 223.301 380.195C223.611 380.245 224.02 380.115 224.3 379.995C224.37 379.885 224.469 379.625 224.499 379.495C219.048 352.375 216.572 324.015 215.054 296.415L215.064 296.405Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.957 436.79C113.319 439.482 119.639 441.844 125.241 443.935C128.795 444.966 139.01 445.546 139.01 445.546L139.109 445.446V445.116",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6144 435.776C103.559 437.618 110.278 440.27 114.282 441.921C117.927 442.901 121.791 443.722 125.535 444.032",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.735 422.184C328.729 423.284 271.417 430.019 263.1 431.851C261.103 432.331 258.896 433.231 257.069 434.162L255.362 435.173C255.122 435.253 254.813 435.353 254.543 435.413",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.826 435.674C229.499 437.416 219.854 438.797 200.683 427.318",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.781 422.186L486.545 422.216V422.186L486.844 422.075L487.044 421.885L487.144 421.685M487.144 421.685V417.052M487.144 421.685V406.775L487.044 406.474L486.844 406.174H486.545L481.822 406.164L475.891 406.274",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.573 448.824L795.403 448.644L795.303 448.344L795.194 419.243L794.694 417.732L487.139 417.222L487.238 447.233L486.939 447.743",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.455 422.184C370.027 421.673 443.503 422.124 475.804 422.184L475.903 406.272C447.308 406.483 418.352 407.213 389.796 408.894C379.572 409.635 369.048 410.425 358.854 411.406C349.798 412.397 338.725 414.028 329.719 415.639C329.719 415.789 329.719 416.089 329.719 416.24C331.896 418.621 334.821 420.843 337.756 422.184H338.455Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.174 386.84C60.3967 393.184 73.7761 396.647 86.147 399.829C113.774 406.624 153.273 413.409 181.2 419.063C183.976 419.964 186.352 422.085 188.928 423.396C192.503 425.367 196.666 426.668 200.69 427.329",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.576 358.438V358.939L28.2749 363.672C28.2749 363.672 28.4646 364.373 28.7741 365.233",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2352 414.329C55.0716 411.427 51.1677 407.684 47.6531 403.751C47.3336 403.371 46.9941 402.971 46.6446 402.55C44.2583 399.668 42.3513 396.796 40.8536 393.784C36.5602 384.798 32.2369 374.53 28.7922 365.184C30.7991 368.066 33.3751 370.788 35.7215 373.339C40.3044 378.453 46.8643 383.797 51.0978 389.151C60.9027 400.849 69.1899 414.749 81.8204 423.655C74.0324 421.334 66.1645 418.612 59.2352 414.329Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.806 423.658C81.806 423.658 81.8859 423.688 81.9358 423.698L82.1355 423.898C82.0257 423.818 81.9159 423.738 81.806 423.658Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.135 423.896C87.1972 427.089 93.0382 428.95 98.8093 430.341C131.04 434.714 221.83 439.568 253.241 439.608",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.331 438.064C126.731 440.796 133.86 443.548 140.52 445.54C144.853 445.92 149.546 446.43 153.879 446.651C168.217 447.601 182.815 448.382 197.183 448.662C212.768 449.152 228.614 449.363 244.2 449.363C250.81 449.403 257.889 449.072 264.499 448.862C267.884 448.562 270.599 447.331 273.864 446.41",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.544 443.731L199.997 442.42L197.99 442.32L117.304 437.887L99.0129 435.675L84.2457 433.454C68.8395 431.582 52.7642 427.539 41.1422 416.642C34.2428 410.007 28.9009 401.491 24.7673 392.875C18.517 380.516 13.0155 366.956 9.79049 353.497C9.79049 353.497 9.28128 353.126 8.59234 350.775C6.68528 344.93 6.29588 333.042 5.67684 327.008C4.92799 316.6 3.89958 305.402 3.07085 294.985C1.38346 280.144 0.854269 264.223 1.04398 247.951",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.432 414.909C275.432 414.909 277.269 408.054 267.315 408.675C267.315 408.675 254.974 409.005 242.193 411.567C242.193 411.567 226.408 414.689 209.065 419.252C209.065 419.252 201.167 404.542 196.614 390.392C196.614 390.392 196.424 390.011 196.823 389.831L197.582 389.651C197.582 389.651 189.455 366.755 185.321 326.736C185.321 326.736 180.968 289.92 181.307 247.96",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.323 415.995H203.209C203.209 415.995 196.47 401.275 193.724 392.108C193.724 392.108 187.004 382.711 185.816 377.648C185.756 377.378 185.726 377.107 185.726 376.827L185.667 365.129L180.584 336.038L181.673 335.237L179.955 322.979C179.955 322.979 178.987 322.348 178.867 321.488C178.867 321.488 176.011 287.864 175.692 277.766L175.243 265.267C175.243 265.267 175.592 264.247 176.191 263.866L176.151 255.36",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.649 247.972C169.919 377.474 199.274 420.965 199.274 420.965L200.681 421.235H201.3C251.144 418.994 329.203 407.696 329.203 407.696",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.084 247.972V253.746L175.853 254.316L176.402 254.446V247.972H175.084Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.084 253.744L175.513 254.645L176.202 255.355L176.552 254.825L175.933 254.485L175.084 253.744Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.732 293.885C255.746 294.286 270.753 294.916 272.929 294.396C274.597 293.495 277.842 285.96 278.6 284.429C278.62 284.389 278.66 284.249 278.66 284.209C278.68 283.828 278.58 283.448 278.251 283.218C277.682 282.798 259.909 282.577 256.544 283.118C255.895 283.118 252.081 291.154 251.422 292.184C251.283 292.444 251.083 292.885 251.123 293.185C251.123 293.185 251.063 293.785 251.722 293.885H251.732Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.084 293.806C218.084 293.806 255.956 297.528 271.641 297.628C279.839 297.739 288.226 297.869 296.353 296.618C299.498 292.495 302.544 287.521 304.291 282.618C304.291 282.618 305.3 279.656 305.389 279.285V279.305C305.549 278.745 304.651 279.045 304.651 279.045C300.267 280.786 238.103 279.195 217.275 279.706C217.275 279.706 217.515 289.272 218.084 293.806ZM218.084 293.806C217.974 292.985 217.984 293.806 217.984 293.806H218.084Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.884 295.193C285.979 295.133 289.464 295.082 292.529 294.682C292.529 294.682 293.078 294.632 293.737 293.671C294.636 292.361 295.944 290.459 296.653 289.038C297.741 287.147 298.909 284.795 299.468 282.694C299.518 282.463 299.369 282.493 299.369 282.493C296.363 282.664 293.028 282.664 289.993 282.784C289.694 282.794 289.404 282.914 289.204 283.144C288.515 283.945 288.006 285.626 287.607 286.316C286.309 289.108 283.882 292.18 282.285 294.772C282.285 294.772 281.935 295.273 282.884 295.173V295.193Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.249 297.217C295.111 326.268 291.876 383.869 289.919 413.03",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.821 410.503C247.552 400.496 239.524 323.081 241.791 315.135C242.739 308.38 246.384 301.956 251.536 297.513C252.754 297.583 254.441 297.743 255.659 297.913C250.497 302.296 246.603 308.38 245.515 315.135C243.248 322.841 250.467 400.376 250.637 409.993L247.821 410.493V410.503Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.151 278.884L267.397 278.954L283.482 278.984H287.905C287.905 278.984 291.37 265.634 291.37 247.972",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.391 296.586L297.379 296.416C297.379 296.416 304.328 288.321 306.835 278.554L305.626 277.863L305.457 278.343C305.457 278.343 294.234 279.814 289.831 279.074C289.831 279.074 293.196 262.942 293.196 247.972",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.941 272.735L291.43 273.956C291.43 273.956 299.398 273.806 300.996 273.516L301.525 272.495V271.815C301.525 271.815 303.512 262.428 303.512 247.978",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.189 247.972L293.321 266.315C293.321 266.315 293.321 266.895 293.95 266.895H300.41C300.41 266.895 301.239 267.185 301.328 265.294C301.328 265.294 302.347 258.589 302.347 247.972",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.009 247.972C308.009 360.892 330.465 402.952 330.465 402.952C329.426 403.803 330.385 404.964 330.385 404.964C331.084 406.785 329.766 407.406 329.766 407.406C329.107 407.366 329.147 408.106 329.147 408.106L330.495 412.019L334.349 411.428C334.349 411.428 337.873 410.698 335.447 406.705L334.439 403.903C334.439 403.903 311.514 366.556 311.514 247.982",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.101 407.124L335.453 406.693",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.506 406.225L335.109 405.835",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.077 405.903C335.077 405.903 337.354 405.762 338.003 411.857C338.003 411.857 338.053 412.787 339.81 412.417C339.81 412.417 360.278 407.514 402.423 406.663L477.178 403.911",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.313 403.85L359.175 400.537L477.173 395.994",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.614 391.705V396.118",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.787 296.646L367.286 297.147L367.386 297.247C373.926 304.572 379.387 309.005 388.234 312.358C388.873 312.598 390.291 312.958 390.291 312.958C393.126 313.989 396.621 314.699 399.636 315.09C413.265 315.82 441.042 316.781 454.492 317.281",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.796 295.732C371.792 298.955 374.967 302.617 378.661 305.079C378.821 305.189 378.951 305.299 378.951 305.299C386.149 310.103 394.736 312.995 403.383 313.335C403.613 313.335 403.902 313.365 404.012 313.375C418.929 313.915 435.154 314.446 450.081 315.076",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.245 299.415C372.824 298.925 375.899 298.024 376.469 298.004C378.336 297.644 383.009 297.404 383.009 297.404C393.383 297.093 404.206 298.925 414.35 301.036C418.933 302.047 424.215 303.648 428.818 304.459C431.983 304.759 435.238 305.359 438.433 305.449C438.613 305.449 438.763 305.459 438.763 305.459C440.26 305.549 441.888 305.579 443.385 305.559",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.298 300.365C366.853 302.177 365.086 305.079 364.367 306.309C362.32 309.462 360.683 322.221 359.844 325.954L358.436 337.932L357.827 343.976L357.428 349.921C357.118 356.665 357.009 360.658 358.896 373.107V373.067C360.573 378.561 362.67 382.854 368.042 385.096",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.338 302.39C439.532 302.289 436.687 301.829 433.901 301.479C422.499 299.127 409.169 295.344 397.627 293.923C390.378 293.273 381.402 293.143 374.113 294.154C373.944 294.174 371.777 294.714 370.898 295.024C369.241 295.635 367.334 296.295 365.976 297.146C364.388 298.106 362.262 300.068 362.262 300.068C357.928 304.181 357.03 311.226 356.031 316.88L354.623 324.535L353.415 332.191C353.116 334.743 352.347 341.307 352.117 343.769L351.718 351.525C351.668 361.121 352.896 371.239 356.64 380.125C358.088 383.397 360.494 386.349 363.669 388.081C363.669 388.081 364.378 388.491 365.167 388.921C365.377 389.031 365.586 389.131 365.806 389.212C367.294 389.762 368.861 390.402 370.449 390.823C378.706 392.844 391.427 393.294 401.251 392.204C411.675 391.283 423.986 388.371 434.54 387.841L436.497 387.781H440.271",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.621 384.905C436.39 384.204 431.427 384.435 426.195 384.745C419.216 385.405 411.638 387.226 404.519 387.837C404.519 387.837 403.041 387.987 402.462 388.047C395.363 388.728 387.914 388.928 380.885 388.377C377.291 387.927 373.536 387.717 370.242 386.166",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.484 304.901C471.294 306.062 470.765 310.996 470.575 312.257C470.296 313.588 470.166 314.078 469.627 314.618C469.117 315.119 468.458 315.419 467.76 315.519C463.107 316.2 457.326 316.23 452.693 316.39C450.896 316.3 449.628 314.648 448.569 313.568C445.584 310.255 443.367 306.603 442.339 302.39",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.446 388.173C468.256 387.012 467.727 382.078 467.538 380.818C467.258 379.487 467.128 378.996 466.589 378.456C466.08 377.955 465.421 377.655 464.722 377.555C460.069 376.875 454.288 376.845 449.655 376.685C447.858 376.775 446.59 378.426 445.532 379.507C442.546 382.819 440.33 386.472 439.301 390.685",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.072 317.072L469.463 346.693L468.055 376.205",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 376.203C467.507 375.933 453.478 374.772 452.48 374.692",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.603 316.382L454.495 317.292",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.386 376.886L453.494 347.004L454.502 317.293",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.076 373.884L387.074 345.894L387.174 343.072L388.282 312.36",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.987 373.079L431.996 344.779L433.095 316.479",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.508 373.878C437.052 373.558 410.443 371.817 394.877 372.097C391.292 372.567 389.166 372.967 385.382 373.978C383.844 374.589 382.176 375.019 380.659 375.689C379.68 376.34 378.562 376.92 377.544 377.501C373.081 380.663 368.248 384.426 364.783 388.679",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.681 389.49C375.557 381.294 377.395 377.692 389.795 374.99C392.711 374.409 395.656 373.949 398.632 373.879C414.527 374.399 432.05 375.21 447.966 375.69L449.873 375.79L452.409 375.89",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.495 318.553L457.47 318.392C457.47 318.392 469.931 317.462 470.051 317.081C470.051 317.081 472.068 315.54 472.427 305.533",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.941 317.073C494.041 308.156 492.953 307.766 492.953 307.766C485.933 301.532 460.642 298.159 460.642 298.159L450.658 297.469C440.973 297.959 442.261 302.322 442.261 302.322C442.261 302.322 443.349 297.469 460.143 301.632L470.218 304.304C470.218 304.304 480.691 307.666 480.102 317.183L480.003 348.195C480.003 348.195 479.643 381.279 475.26 384.031L468.44 388.194C468.44 388.194 447.792 396.019 439.295 390.966",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.112 297.757L468.152 300.829C468.152 300.829 477.148 303.111 480.303 307.764C480.303 307.764 482.579 310.046 482.579 317.271",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.812 307.263C479.812 307.263 482.188 306.172 492.952 307.753",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.315 390.955C439.315 390.955 438.856 394.427 444.747 394.888C444.747 394.888 454.232 396.659 471.436 389.974L476.019 386.762C476.019 386.762 478.814 385.171 479.613 381.188C479.613 381.188 480.921 375.414 480.921 372.792",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.903 376.211C467.903 376.211 469.29 376.511 469.29 379.483L469.27 387.669",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.021 385.971C477.021 385.971 484.789 387.262 490.451 386.211",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.604 395.139C446.604 395.139 459.924 396.31 474.99 392.667L485.255 389.935C485.255 389.935 491.425 388.174 491.425 383.231L492.204 373.794",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.251 354.43C499.711 367.259 497.854 369.921 497.854 369.921C496.327 373.694 492.772 373.674 492.772 373.674L482.857 373.624C481.21 373.584 479.962 372.082 480.052 370.271L481.759 345.554L481.679 342.461V319.865C481.679 318.214 483.017 316.873 484.665 316.873L494.599 317.073C494.599 317.073 498.174 317.143 499.502 320.616C499.502 320.616 501.748 323.838 500.9 340.38C500.9 340.38 500.32 352.609 500.241 354.43H500.251Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.076 369.979C480.076 369.979 483.421 369.759 485.348 361.303C485.348 361.303 486.546 357.16 486.976 349.445C487.036 348.344 487.455 340.428 487.415 339.517C487.215 333.803 486.487 328.53 486.487 328.53C485.059 319.733 481.684 320.134 481.684 320.134",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.171 71.1359C828.622 70.9858 826.575 70.7756 825.846 70.2353C825.108 69.7849 824.838 68.9143 824.718 67.9636C824.598 67.013 824.389 64.6012 824.379 64.251C824.309 62.4297 824.489 60.4883 824.848 58.7571C825.078 57.6363 825.747 56.5355 825.747 56.5355C825.747 56.5355 826.106 55.805 826.655 55.5348C829.381 55.0044 832.396 54.9644 835.262 54.9443L1125.37 58.4568C1123.09 61.0387 1120.16 63.8707 1117.63 66.2124C1116.14 67.6034 1114.21 69.7049 1112.41 70.6456C1108.69 72.3067 1104.35 72.5669 1100.35 72.9572L1081.65 73.1573L829.75 71.206L829.161 71.1459L829.171 71.1359Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.52 50.9908C950.089 46.5176 687.134 46.6677 495.729 48.1988C492.704 48.2188 483.139 48.1688 481.052 48.1388C443.22 47.5784 331.273 51.6213 285.354 50.5005",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.082 71.1979L795.204 70.9277",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.07 91.9883H500.711V99.944H1125.07V91.9883Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.7 77.8811L1129.39 77.2706L1129.09 77.1705L1123.36 76.9804L1114.23 76.6702L1104.98 76.4701L1095.73 76.2699L1086.49 76.1698L1068.11 75.9698L1050.72 75.7595L795.216 73.9482",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.21 246.958V247.859V247.959L1173.31 248.169L1173.61 248.259H1175.32H1176.73L1176.92 248.359L1177.12 248.469V248.979",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.38 246.949V247.96V248.26L1190.49 248.47L1190.73 248.961",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.65 113.728L1163.75 120.382L1165.27 129.739L1166.47 138.705L1167.67 147.972L1168.27 154.106L1168.88 160.351L1169.99 172.84L1170.49 179.795L1170.99 186.84L1171.7 200.229L1172.1 211.407L1172.3 219.263L1172.5 227.219L1172.7 238.497V246.252V246.452L1172.8 246.753L1172.9 246.963H1173H1192.3",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.92 102.854L1176.02 103.055",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.19 87.8877L1176.02 103.058",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 246.963C1186.59 243.261 1185.13 206.234 1186.76 203.863C1186.82 199.48 1186.7 194.946 1186.56 190.573C1185.52 169.248 1183.67 147.182 1180.73 126.027C1179.97 120.633 1179.08 114.819 1177.92 109.515C1177.37 107.434 1177.12 104.922 1176.01 103.071L1175.91 102.871C1175.77 102.76 1175.48 102.6 1175.3 102.57C1173.54 104.161 1171.69 106.253 1169.98 107.904C1168.8 109.235 1166.94 110.716 1166.86 112.638",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.05 110.503L1161.45 106.981V106.681L1161.24 102.638",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.05 110.505L1162.65 113.727",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.23 74.7559C1183.63 84.5028 1185.99 96.3313 1187.38 107.139C1187.52 108.2 1187.6 109.17 1187.67 110.041C1190.42 145.987 1192.66 212.964 1192.3 246.949",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.15 53.8184L1138.54 53.9084C1147.76 54.5089 1158.17 56.2801 1167.09 58.8119L1169.21 59.3123L1173 57.6311",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.17 54.6115C1157.26 52.3098 1145.32 51.2491 1137.03 50.4785C1136.68 50.4785 1136.44 50.7387 1136.13 50.8788",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.64 55.2834L1166.27 54.6029C1166.27 54.6029 1166.9 54.5028 1167.17 55.6236L1167.8 58.7058L1155.73 55.5436C1155.73 55.5436 1155.5 55.4435 1155.65 55.2834H1155.64Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.08 55.3262C1167.08 55.3262 1170 56.2668 1170.18 56.3369C1170.18 56.3369 1172.42 56.9373 1173 57.6478L1173.53 58.1682L1173.48 58.3283L1169.38 59.9795",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.61 50.999L1137.82 51.3493L1138.24 54.7017L1136.03 61.4565L1128.88 77.1677",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.2 59.3154L1169.38 59.9659L1169.69 62.0074",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.4 61.2674L1155.18 82.1123C1155.18 82.1123 1152.61 85.7649 1153.45 91.9994L1155.32 101.086H1131.29L1129.65 90.9686L1127.69 90.5984C1128.67 79.3103 1129.79 77.5791 1129.79 77.5791L1137.08 61.8378L1139.23 55.0029L1144.32 55.5133L1152.55 56.6841L1158.63 57.9951L1166.81 60.5669C1166.81 60.5669 1169.66 60.8971 1171.43 64.92C1171.43 64.92 1173.73 69.7134 1174.73 74.4969C1174.73 74.4969 1174.84 75.0472 1174.59 75.3975L1170.49 80.251",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.69 90.5986C1127.69 90.5986 1127.64 91.3992 1127.22 91.3492V92.8002",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.13 92.8105H1127.48C1127.48 92.8105 1127.56 101.376 1126.9 102.687",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.12 71.2305L1157.19 84.0796C1157.46 82.7787 1153.55 81.3176 1150.63 80.4269C1148.97 79.9166 1147.29 79.5264 1145.58 79.2262L1141.24 78.4556L1129.93 77.3749",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.46 69.3128C1169.27 73.2055 1170.42 80.0504 1170.42 80.0504C1170.45 81.0511 1168.81 81.1812 1168.81 81.1812C1167.26 74.3464 1164.75 70.5136 1164.75 70.5136L1164.49 67.8717C1164.49 67.8717 1165.18 67.4915 1166.23 69.0025L1166.46 69.3128Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.53 63.2695L1166.5 69.2638",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.8 81.1817L1168.94 81.7021L1161.42 92.4998L1160.9 95.7621L1161.5 94.381L1162.43 93.1602L1169.69 82.7327L1174.9 76.5284C1174.9 76.5284 1175.32 76.1882 1175.46 77.1088L1175.96 79.0702L1178.19 78.4898C1178.19 78.4898 1179.83 78.1495 1179.56 76.4082C1178.11 67.3317 1174.67 60.2367 1174.67 60.2367L1173.81 58.4355L1173.55 58.1553",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.86 83.9523C1168.86 83.9523 1169.33 83.7521 1169.44 84.3225L1170.5 88.4855C1170.5 88.4855 1170.63 89.206 1170.84 89.0959L1172.01 87.6149C1172.01 87.6149 1172.14 87.3947 1171.96 86.8143L1170.85 82.0409C1170.85 82.0409 1170.82 81.7707 1170.45 81.8508",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.76 78.1689L1178.44 80.4506C1178.44 80.4506 1178.23 81.1411 1177.38 82.2018L1165.89 97.7028C1165.89 97.7028 1164.65 98.7035 1165.55 105.708",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.91 92.5117L1166.94 112.887L1171.29 149.083L1175.05 181.346L1176.96 246.953",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.66 81.6738L1161.37 86.4858",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.21 86.2627L1162.54 90.6858V90.856",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.9 95.7607L1161.24 102.636",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.24 102.638L1125.26 102.718",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.171 424.801C828.622 424.951 826.575 425.161 825.846 425.701C825.108 426.152 824.838 427.022 824.718 427.973C824.598 428.924 824.389 431.335 824.379 431.686C824.309 433.507 824.489 435.448 824.848 437.18C825.078 438.3 825.747 439.401 825.747 439.401C825.747 439.401 826.106 440.132 826.655 440.402C829.381 440.932 832.396 440.972 835.262 440.992L1125.37 437.48C1123.09 434.898 1120.16 432.066 1117.63 429.724C1116.14 428.333 1114.21 426.232 1112.41 425.291C1108.69 423.63 1104.35 423.37 1100.35 422.979L1081.65 422.779L829.75 424.731L829.161 424.791L829.171 424.801Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.52 444.941C950.089 449.415 687.134 449.265 495.729 447.733C492.704 447.713 483.139 447.763 481.052 447.793C443.22 448.354 331.273 444.311 285.354 445.432",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.082 424.739L795.204 425.009",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.07 395.988H500.711V403.944H1125.07V395.988Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.7 418.05L1129.39 418.66L1129.09 418.76L1123.36 418.95L1114.23 419.261L1104.98 419.461L1095.73 419.661L1086.49 419.761L1068.11 419.961L1050.72 420.171L795.216 421.983",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.65 382.209L1163.75 375.554L1165.27 366.197L1166.47 357.231L1167.67 347.964L1168.27 341.83L1168.88 335.585L1169.99 323.097L1170.49 316.142L1170.99 309.097L1171.7 295.707L1172.1 284.529L1172.3 276.673L1172.5 268.718L1172.7 257.44V249.684V249.484L1172.8 249.184L1172.9 248.974L1173 248.984H1192.3",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.92 393.074L1176.02 392.874",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.19 408.045L1176.02 392.874",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 248.982C1186.59 252.685 1185.13 289.712 1186.76 292.083C1186.82 296.466 1186.7 301 1186.56 305.373C1185.52 326.698 1183.67 348.764 1180.73 369.919C1179.97 375.313 1179.08 381.127 1177.92 386.431C1177.37 388.512 1177.12 391.024 1176.01 392.875L1175.91 393.075C1175.77 393.185 1175.48 393.346 1175.3 393.376C1173.54 391.784 1171.69 389.693 1169.98 388.042C1168.8 386.711 1166.94 385.23 1166.86 383.308",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.05 385.433L1161.45 388.955V389.255L1161.24 393.298",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.05 385.426L1162.65 382.204",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.23 421.175C1183.63 411.428 1185.99 399.6 1187.38 388.792C1187.52 387.732 1187.6 386.761 1187.67 385.89C1190.42 349.945 1192.66 282.967 1192.3 248.982",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.15 442.119L1138.54 442.029C1147.76 441.428 1158.17 439.657 1167.09 437.125L1169.21 436.625L1173 438.306",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.17 441.316C1157.26 443.618 1145.32 444.679 1137.03 445.449C1136.68 445.449 1136.44 445.189 1136.13 445.049",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.64 440.647L1166.27 441.328C1166.27 441.328 1166.9 441.428 1167.17 440.307L1167.8 437.225L1155.73 440.387C1155.73 440.387 1155.5 440.487 1155.65 440.647H1155.64Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.61 444.932L1137.82 444.582L1138.24 441.23L1136.03 434.475L1128.88 418.764",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.2 436.618L1169.38 435.967L1169.69 433.926",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.4 434.666L1155.18 413.821C1155.18 413.821 1152.61 410.169 1153.45 403.934L1155.32 394.848H1131.29L1129.65 404.965L1127.69 405.335C1128.67 416.623 1129.79 418.354 1129.79 418.354L1137.08 434.096L1139.23 440.931L1144.32 440.42L1152.55 439.249L1158.63 437.938L1166.81 435.367C1166.81 435.367 1169.66 435.036 1171.43 431.014C1171.43 431.014 1173.73 426.22 1174.73 421.437C1174.73 421.437 1174.84 420.886 1174.59 420.536L1170.49 415.683",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.69 405.337C1127.69 405.337 1127.64 404.537 1127.22 404.587V403.136",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.13 403.124H1127.48C1127.48 403.124 1127.56 394.558 1126.9 393.247",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.12 424.698L1157.19 411.849C1157.46 413.15 1153.55 414.611 1150.63 415.501C1148.97 416.012 1147.29 416.402 1145.58 416.702L1141.24 417.473L1129.93 418.553",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.46 426.619C1169.27 422.727 1170.42 415.882 1170.42 415.882C1170.45 414.881 1168.81 414.751 1168.81 414.751C1167.26 421.586 1164.75 425.419 1164.75 425.419L1164.49 428.06C1164.49 428.06 1165.18 428.441 1166.23 426.93L1166.46 426.619Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.53 432.663L1166.5 426.669",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.8 414.751L1168.94 414.231L1161.42 403.433L1160.9 400.171L1161.5 401.552L1162.43 402.773L1169.69 413.2L1174.9 419.405C1174.9 419.405 1175.32 419.745 1175.46 418.824L1175.96 416.863L1178.19 417.443C1178.19 417.443 1179.83 417.783 1179.56 419.525C1178.11 428.601 1174.67 435.696 1174.67 435.696L1173.81 437.498L1173.55 437.778",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.86 411.977C1168.86 411.977 1169.33 412.178 1169.44 411.607L1170.5 407.444C1170.5 407.444 1170.63 406.724 1170.84 406.834L1172.01 408.315C1172.01 408.315 1172.14 408.535 1171.96 409.115L1170.85 413.889C1170.85 413.889 1170.82 414.159 1170.45 414.079",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.76 417.763L1178.44 415.482C1178.44 415.482 1178.23 414.791 1177.38 413.73L1165.89 398.229C1165.89 398.229 1164.65 397.229 1165.55 390.224",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.91 403.423L1166.94 383.048L1171.29 346.852L1175.05 314.589L1176.96 248.982",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.66 414.262L1160.26 411.64L1161.37 409.116",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.21 409.667L1162.54 405.244V405.074",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.9 400.169L1161.24 393.294",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.24 393.292L1125.26 393.212",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.237 443.931C128.791 444.962 139.006 445.542 139.006 445.542L139.106 445.442L140.513 445.542C144.847 445.923 149.539 446.433 153.873 446.653C168.211 447.604 182.808 448.384 197.176 448.665C212.762 449.155 228.608 449.365 244.193 449.365C250.803 449.405 257.882 449.075 264.492 448.865C267.098 448.635 271.491 447.184 273.858 446.413L274.337 451.577H274.347C273.628 451.667 272.909 451.827 272.23 452.077C271.771 452.227 270.942 452.507 270.513 452.988C270.163 453.398 270.213 453.698 270.213 453.698C270.523 458.211 271.871 464.276 272.929 468.699C273.309 470.27 273.698 471.841 274.117 473.402C274.497 474.793 274.886 476.174 275.325 477.545C275.695 478.676 276.054 479.857 276.643 480.888C278.82 484.71 281.945 490.715 284.781 493.877C284.781 493.877 285.36 494.678 286.488 494.778L288.395 494.878C289.004 494.878 293.048 491.105 293.408 490.464C293.617 490.074 293.687 489.664 293.428 489.234H293.527L294.236 489.634H294.336L297.801 488.043C297.801 488.043 297.841 488.063 297.851 488.073C298.61 487.773 298.29 486.842 298.35 486.201C296.673 478.136 293.028 464.926 291.041 456.8C291.021 456.73 291.001 456.67 290.981 456.6L290.043 453.778C289.953 453.518 289.793 453.288 289.574 453.128L287.477 451.567C287.297 451.427 287.087 451.317 286.878 451.246L285.5 450.736C285.031 449.085 284.881 447.564 285.13 446.223H286.239L369.39 446.043C413.373 446.903 504.193 447.784 504.193 447.784C581.224 448.374 669.248 448.745 758.99 448.675L795.563 448.805C795.563 448.805 1031.82 447.364 1130.44 445.092C1132.56 445.042 1136.1 445.032 1136.1 445.032C1136.42 445.172 1136.65 445.432 1137 445.432C1145.29 444.662 1157.23 443.611 1165.14 441.299H1166.24C1166.24 441.299 1166.74 441.379 1167.05 440.599C1167.05 440.599 1169.98 439.658 1170.16 439.588C1170.16 439.588 1172.4 438.988 1172.97 438.277L1173.5 437.757L1173.76 437.477L1174.63 435.675C1174.63 435.675 1177.68 429.361 1179.24 421.035C1183.62 411.308 1185.96 399.54 1187.35 388.762C1187.49 387.701 1187.57 386.73 1187.64 385.86C1190.35 350.515 1192.55 285.138 1192.28 250.663C1192.28 250.083 1192.28 245.049 1192.28 244.078C1192.5 209.324 1190.31 144.988 1187.64 110.023C1187.57 109.152 1187.49 108.181 1187.35 107.121C1185.96 96.343 1183.62 84.5746 1179.24 74.8476C1177.68 66.5217 1174.63 60.2072 1174.63 60.2072L1173.76 58.4059L1173.5 58.1257L1172.97 57.6053C1172.4 56.8948 1170.16 56.2944 1170.16 56.2944C1169.97 56.2243 1167.05 55.2937 1167.05 55.2837C1166.74 54.5031 1166.24 54.5731 1166.24 54.5731H1165.14C1157.23 52.2715 1145.29 51.2208 1137 50.4502C1136.65 50.4502 1136.41 50.7104 1136.1 50.8505C1136.1 50.8505 1132.56 50.8305 1130.44 50.7904C1031.82 48.5188 795.563 47.0778 795.563 47.0778L758.99 47.2079C669.248 47.1478 581.224 47.5081 504.193 48.0985C504.193 48.0985 413.363 48.9691 369.39 49.8398L286.239 49.6596H285.13C284.881 48.3287 285.031 46.8076 285.5 45.1564L286.878 44.636C287.087 44.556 287.297 44.4459 287.477 44.3158L289.574 42.7547C289.793 42.5946 289.963 42.3644 290.043 42.1042L290.981 39.2822C291.001 39.2122 291.021 39.1521 291.041 39.0821C293.028 30.9563 296.663 17.7368 298.35 9.68108C298.29 9.04062 298.61 8.11997 297.851 7.80974C297.831 7.80974 297.811 7.82976 297.801 7.83976L294.336 6.24863H294.236L293.527 6.64891H293.428C293.687 6.21861 293.617 5.80831 293.408 5.41803C293.048 4.77758 289.004 1.00488 288.395 1.00488L286.488 1.10495C285.36 1.20503 284.781 2.0056 284.781 2.0056C281.945 5.17786 278.82 11.1822 276.643 14.9949C276.054 16.0256 275.695 17.2065 275.325 18.3373C274.886 19.7082 274.487 21.0892 274.117 22.4802C273.698 24.0413 273.309 25.6025 272.929 27.1836C271.871 31.6067 270.533 37.6711 270.213 42.1843C270.213 42.1843 270.163 42.4845 270.513 42.8948C270.932 43.3651 271.771 43.6553 272.23 43.8055C272.909 44.0556 273.628 44.2157 274.347 44.2958H274.337L273.888 49.4995C271.521 48.739 267.098 47.2579 264.492 47.0278C257.882 46.8176 250.803 46.4874 244.193 46.5274C228.608 46.5274 212.752 46.7476 197.176 47.2279C182.798 47.5081 168.211 48.2887 153.873 49.2393C149.539 49.4495 144.847 49.9699 140.513 50.3501L139.106 50.4502L139.006 50.3501C139.006 50.3501 128.791 50.9305 125.237 51.9613M125.536 51.8612C121.792 52.1814 117.928 53.002 114.284 53.9727C110.28 55.6239 103.56 58.2758 99.616 60.1171L99.0071 60.2172L84.2399 62.4388C68.8336 64.3101 52.7584 68.353 41.1363 79.2508C34.237 85.8855 28.8951 94.4016 24.7615 103.018C18.5111 115.377 13.0096 128.936 9.78463 142.396C9.78463 142.396 9.27542 142.766 8.58648 145.118C6.67942 150.962 6.29002 162.85 5.67097 168.885C4.92213 179.292 3.89372 190.49 3.06499 200.908C1.3776 215.748 0.848412 231.67 1.03812 247.941C0.848412 264.213 1.3776 280.124 3.06499 294.975C3.89372 305.392 4.92213 316.59 5.67097 326.998C6.29002 333.032 6.67942 344.921 8.58648 350.765C9.2854 353.116 9.78463 353.487 9.78463 353.487C13.0096 366.946 18.5111 380.506 24.7615 392.865C28.8951 401.481 34.237 409.997 41.1363 416.632C52.7584 427.54 68.8336 431.572 84.2399 433.444L99.0071 435.665L99.616 435.765C103.56 437.607 110.28 440.259 114.284 441.91C117.928 442.891 121.792 443.711 125.536 444.021",
    stroke: "#26231E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.155 48.7686V92.0195",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.595 79.6891V50.2881",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.271 396.307C514.271 396.307 516.139 393.835 528.27 393.835C540.401 393.835 587.109 393.835 587.109 393.835C587.109 393.835 594.408 393.805 598.891 396.067",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.962 99.8027H715.522V181.941H935.962V99.8027Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M935.962 99.8027H715.522V181.941H935.962V99.8027Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.716 136.873H751.503V181.996H829.716V136.873Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M829.716 136.873H751.503V181.996H829.716V136.873Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.673 253.997H542.427C538.925 253.997 536.087 256.842 536.087 260.352V389.554C536.087 393.063 538.925 395.908 542.427 395.908H596.673C600.175 395.908 603.013 393.063 603.013 389.554V260.352C603.013 256.842 600.175 253.997 596.673 253.997Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.708 254.976H614.202C612.647 254.976 611.386 256.238 611.386 257.798V391.173C611.386 392.731 612.647 393.995 614.202 393.995H700.708C702.264 393.995 703.524 392.731 703.524 391.173V257.798C703.524 256.238 702.264 254.976 700.708 254.976Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.278 256.194C613.278 256.194 615.255 259.226 615.255 278.941V374.539C615.255 374.539 615.275 386.397 613.468 393.683",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.875 392.637C700.875 392.637 697.79 389.604 697.79 369.89V274.292C697.79 274.292 697.75 262.434 700.586 255.148",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.326 255.874C700.326 255.874 698.399 259.146 685.918 259.146C673.437 259.146 625.382 259.146 625.382 259.146C625.382 259.146 617.873 259.186 613.26 256.184",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.152 392.814C615.152 392.814 617.019 390.342 629.15 390.342C641.282 390.342 687.99 390.342 687.99 390.342C687.99 390.342 695.289 390.312 699.772 392.573",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.247 392.817C614.247 392.817 638.42 356.2 657.451 350.406",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.864 393.697C700.864 393.697 676.182 356.33 656.762 350.406",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.684 318.042C696.684 318.042 674.569 345.151 657.155 349.444",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.152 318.042C615.152 318.042 638.466 345.151 656.808 349.444",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.365 353.188C657.897 353.188 659.141 351.942 659.141 350.406C659.141 348.87 657.897 347.624 656.365 347.624C654.832 347.624 653.589 348.87 653.589 350.406C653.589 351.942 654.832 353.188 656.365 353.188Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.988 292.922C638.566 296.354 615.152 318.04 615.152 318.04",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.515 318.04C696.515 318.04 674.589 296.354 657.326 292.922",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.321 255.874C700.321 255.874 676.438 287.847 657.637 292.91",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.278 255.874C613.278 255.874 637.391 287.847 656.361 292.91",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.365 295.704C657.897 295.704 659.141 294.458 659.141 292.922C659.141 291.386 657.897 290.14 656.365 290.14C654.832 290.14 653.589 291.386 653.589 292.922C653.589 294.458 654.832 295.704 656.365 295.704Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.013 186.859C618.013 186.859 640.169 151.854 657.612 146.31",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.333 184.907C700.333 184.907 676.629 151.583 657.978 146.31",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.46 104.389C699.46 104.389 676.415 140.575 658.283 146.309",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.013 105.778C618.013 105.778 640.339 140.763 657.902 146.307",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.027 149.091C659.56 149.091 660.803 147.845 660.803 146.309C660.803 144.773 659.56 143.527 658.027 143.527C656.494 143.527 655.252 144.773 655.252 146.309C655.252 147.845 656.494 149.091 658.027 149.091Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.962 101.773H615.297C614.062 101.773 613.061 102.777 613.061 104.015V187.305C613.061 188.542 614.062 189.546 615.297 189.546H702.962C704.197 189.546 705.198 188.542 705.198 187.305V104.015C705.198 102.777 704.197 101.773 702.962 101.773Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.925 185.209L617.945 106.112C617.945 105.422 618.834 104.861 619.922 104.861H698.361C699.45 104.871 700.338 105.432 700.338 106.122L700.318 185.199C700.318 185.889 699.43 186.45 698.341 186.45H619.902C618.814 186.45 617.925 185.889 617.925 185.199V185.209Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.958 280.754H717.655V396.036H935.958V280.754Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1019.21 181.938H938.541V279.667H1019.21V181.938Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.541 99.6738V394.275H1119.14V99.6738H938.541Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M938.541 99.6738V394.275H1119.14V99.6738H938.541Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.21 181.938H938.541V279.667H1019.21V181.938Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.189 108.962H825.613C837.924 108.962 847.919 118.979 847.919 131.318V163.091C847.919 168.404 843.615 172.717 838.314 172.717H744.199C738.897 172.717 734.594 168.404 734.594 163.091V118.589C734.594 113.275 738.897 108.962 744.199 108.962H744.189Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.465 102.411H721.956C720.363 102.411 719.071 103.706 719.071 105.303V175.333C719.071 176.93 720.363 178.225 721.956 178.225H930.465C932.058 178.225 933.35 176.93 933.35 175.333V105.303C933.35 103.706 932.058 102.411 930.465 102.411Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.232 146.408C794.15 146.408 796.514 143.93 796.514 140.874C796.514 137.818 794.15 135.34 791.232 135.34C788.315 135.34 785.95 137.818 785.95 140.874C785.95 143.93 788.315 146.408 791.232 146.408Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.235 145.6C793.722 145.6 795.738 143.486 795.738 140.877C795.738 138.268 793.722 136.153 791.235 136.153C788.748 136.153 786.732 138.268 786.732 140.877C786.732 143.486 788.748 145.6 791.235 145.6Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.14 112.73L839.1 110.686C838.55 110.135 837.658 110.135 837.109 110.686L809.87 137.986C809.321 138.536 809.321 139.43 809.87 139.981L811.911 142.025C812.461 142.577 813.351 142.577 813.902 142.025L841.14 114.726C841.69 114.176 841.69 113.282 841.14 112.73Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.042 117.9C839.761 117.9 841.964 115.88 841.964 113.387C841.964 110.894 839.761 108.874 837.042 108.874C834.324 108.874 832.119 110.894 832.119 113.387C832.119 115.88 834.324 117.9 837.042 117.9Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.701 110.094C833.701 110.094 832.293 111.165 824.754 113.396C821.28 116.849 826.302 118.19 826.302 118.19C826.302 118.19 832.133 117.229 837.055 117.909",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.701 110.094C833.701 110.094 832.293 111.165 824.754 113.396C821.28 116.849 826.302 118.19 826.302 118.19C826.302 118.19 832.133 117.229 837.055 117.909",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.564 104.966V186.334C705.564 188.105 704.126 189.546 702.359 189.546H691.635C687.332 189.546 683.847 186.044 683.847 181.741V108.798C683.847 104.916 686.993 101.773 690.857 101.773H702.369C704.136 101.773 705.574 103.214 705.574 104.986L705.564 104.966Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.555 258.128V392.464C705.555 394.486 703.919 396.137 701.892 396.137H692.735C687.813 396.137 683.83 392.134 683.83 387.21V262.511C683.83 258.078 687.424 254.476 691.847 254.476H701.892C703.909 254.476 705.555 256.117 705.555 258.148V258.128Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.607 100.493H520.17V397.165H710.607V100.493Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M710.607 100.493H520.17V397.165H710.607V100.493Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.509 285.21H722.889V393.397H930.509V285.21Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.65 181.938H933.347V279.667H937.65V181.938Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M952.312 99.0449H497.973V153.654H952.312V99.0449Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.368 299.214H738.012C737.603 299.214 737.273 299.572 737.273 300.015V301.414C737.273 301.858 737.603 302.216 738.012 302.216H843.368C843.775 302.216 844.108 301.858 844.108 301.414V300.015C844.108 299.572 843.775 299.214 843.368 299.214Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.368 308.224H738.012C737.603 308.224 737.273 308.582 737.273 309.025V310.424C737.273 310.868 737.603 311.226 738.012 311.226H843.368C843.775 311.226 844.108 310.868 844.108 310.424V309.025C844.108 308.582 843.775 308.224 843.368 308.224Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.368 317.228H738.012C737.603 317.228 737.273 317.586 737.273 318.029V319.428C737.273 319.871 737.603 320.23 738.012 320.23H843.368C843.775 320.23 844.108 319.871 844.108 319.428V318.029C844.108 317.586 843.775 317.228 843.368 317.228Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.368 326.241H738.012C737.603 326.241 737.273 326.599 737.273 327.043V328.442C737.273 328.885 737.603 329.243 738.012 329.243H843.368C843.775 329.243 844.108 328.885 844.108 328.442V327.043C844.108 326.599 843.775 326.241 843.368 326.241Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.368 335.242H738.012C737.603 335.242 737.273 335.6 737.273 336.044V337.443C737.273 337.886 737.603 338.244 738.012 338.244H843.368C843.775 338.244 844.108 337.886 844.108 337.443V336.044C844.108 335.6 843.775 335.242 843.368 335.242Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.368 344.246H738.012C737.603 344.246 737.273 344.604 737.273 345.048V346.447C737.273 346.89 737.603 347.248 738.012 347.248H843.368C843.775 347.248 844.108 346.89 844.108 346.447V345.048C844.108 344.604 843.775 344.246 843.368 344.246Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.368 353.259H738.012C737.603 353.259 737.273 353.617 737.273 354.06V355.459C737.273 355.903 737.603 356.261 738.012 356.261H843.368C843.775 356.261 844.108 355.903 844.108 355.459V354.06C844.108 353.617 843.775 353.259 843.368 353.259Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.368 362.26H738.012C737.603 362.26 737.273 362.618 737.273 363.061V364.46C737.273 364.904 737.603 365.262 738.012 365.262H843.368C843.775 365.262 844.108 364.904 844.108 364.46V363.061C844.108 362.618 843.775 362.26 843.368 362.26Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.368 371.273H738.012C737.603 371.273 737.273 371.632 737.273 372.075V373.474C737.273 373.917 737.603 374.276 738.012 374.276H843.368C843.775 374.276 844.108 373.917 844.108 373.474V372.075C844.108 371.632 843.775 371.273 843.368 371.273Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.368 380.277H738.012C737.603 380.277 737.273 380.636 737.273 381.079V382.478C737.273 382.921 737.603 383.279 738.012 383.279H843.368C843.775 383.279 844.108 382.921 844.108 382.478V381.079C844.108 380.636 843.775 380.277 843.368 380.277Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.808 289.802H838.942C848.707 289.802 856.625 300.479 856.625 313.649V377.675C856.625 385.12 852.152 391.164 846.621 391.164H744.798M839.695 289.802H745.56C735.795 289.802 727.878 300.479 727.878 313.649V377.675C727.878 385.12 732.351 391.164 737.882 391.164H839.705",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.628 371.446V368.554C927.628 367.774 926.997 367.143 926.22 367.143H887.698C886.923 367.143 886.292 367.774 886.291 368.554L886.292 371.446C886.292 372.225 886.922 372.857 887.699 372.857H926.22C926.997 372.857 927.628 372.225 927.628 371.446Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.085 372.198C923.007 374.124 925.991 374.257 927.75 372.495C929.508 370.732 929.375 367.742 927.453 365.814C925.531 363.889 922.547 363.755 920.788 365.518C919.029 367.28 919.163 370.272 921.085 372.198Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.219 364.303C924.219 364.303 922.468 364.063 915.564 360.298C910.67 360.277 913.276 364.784 913.276 364.784C913.276 364.784 918.077 368.238 921.077 372.206",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.219 364.303C924.219 364.303 922.468 364.063 915.564 360.298C910.67 360.277 913.276 364.784 913.276 364.784C913.276 364.784 918.077 368.238 921.077 372.206",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M679.21 342.099H512.397V396.708H679.21V342.099Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.21 342.099H512.397V396.708H679.21V342.099Z",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.77 320.374H938.012V394.075H1032.77V320.374Z",
    fill: "white",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.408 302.325H982.383L965.086 320.374H974.11L991.408 302.325Z",
    fill: "#D9D9D9",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.45 302.325H997.424L980.127 320.374H989.151L1006.45 302.325Z",
    fill: "#D9D9D9",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.312 99.0449H497.973V153.654H952.312V99.0449Z",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M377.205 99.124H311.097C309.106 99.124 307.492 100.741 307.492 102.737V204.449C307.492 206.445 309.106 208.062 311.097 208.062H377.205C379.196 208.062 380.809 206.445 380.809 204.449V102.737C380.809 100.741 379.196 99.124 377.205 99.124Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.205 99.124H311.097C309.106 99.124 307.492 100.741 307.492 102.737V204.449C307.492 206.445 309.106 208.062 311.097 208.062H377.205C379.196 208.062 380.809 206.445 380.809 204.449V102.737C380.809 100.741 379.196 99.124 377.205 99.124Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06 108.296H311.241C309.995 108.296 308.985 109.309 308.985 110.558L308.985 197.118C308.985 198.367 309.995 199.379 311.241 199.379H377.06C378.306 199.379 379.316 198.367 379.316 197.118L379.316 110.558C379.316 109.309 378.306 108.296 377.06 108.296Z",
    fill: "white",
    stroke: "#25221E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.523 145.898H371.575V162.25H379.523V145.898Z",
    fill: "white",
    stroke: "#25221E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M933.708 282.771H715.404V398.054H933.708V282.771Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.17 318.46L1037.28 306.837L942.847 281.533L939.733 293.156L1034.17 318.46Z",
    fill: "#D9D9D9",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.396 46.627L252.892 56.4036",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarBayrun4Rent);
export default __webpack_public_path__ + "static/media/car_bayrun4_rent.2e47571bc9571cce4358be95a9086b27.svg";
export { ForwardRef as ReactComponent };